const FormData = require("form-data");
import axios from "axios";
import config from "../config";
import { Printd } from "printd";
var useCustomServer = "";

export function _getDate(_d) {
  let event;
  if(_d == null) {
    event = new Date();
  } else {
    event = new Date(_d);
  }
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
return event.toLocaleDateString("fr-FR", options)
}

export function getAppPath() {
  return config.paths.appPath;
}

export function getAppShopPath() {
  return config.paths.shopPath;
}

export function resolveMediaPath(path, fallback = "uploads/catalogue/No-Image.jpg") {
  const getRuntimeBase = () => {
    if (typeof window !== "undefined" && window.location && window.location.origin) {
      return `${window.location.origin}/`;
    }

    return getAppPath();
  };

  if (path && /^https?:\/\//i.test(path)) {
    return path;
  }

  if (path && String(path).trim() !== "") {
    return getRuntimeBase() + String(path).split("./").join("").replace(/^\/+/, "");
  }

  return getRuntimeBase() + fallback.replace(/^\/+/, "");
}

export function httpAction(payload) {
  useCustomServer = "";
  if (payload.server) {
    useCustomServer = payload.server;
  }
  switch (payload.methode) {
    case "C_POST":
      custompostAction(payload);
      break;
    case "POST":
      postAction(payload);
      break;
    case "PUT":
      putAction(payload);
      break;
    case "DELETE":
      deleteAction(payload);
      break;
    case "GET":
      getAction(payload);
      break;
  }
}

function readCookieValue(name) {
  if (typeof document === "undefined") {
    return "";
  }

  const cookiePrefix = `${name}=`;
  const cookies = document.cookie ? document.cookie.split(";") : [];

  for (const cookieEntry of cookies) {
    const trimmed = cookieEntry.trim();

    if (trimmed.startsWith(cookiePrefix)) {
      return trimmed.slice(cookiePrefix.length);
    }
  }

  return "";
}

export function buildAuthHeaders() {
  const userContext = readCookieValue("user");

  if (!userContext) {
    return {};
  }

  let decodedUserContext = userContext;

  try {
    decodedUserContext = decodeURIComponent(userContext);
  } catch (error) {
    decodedUserContext = userContext;
  }

  let sessionToken = '';
  try {
    sessionToken = JSON.parse(decodedUserContext).sessionToken || '';
  } catch (error) {
    sessionToken = '';
  }

  return {
    "X-User-Context": decodedUserContext,
    ...(sessionToken ? { "X-Session-Token": sessionToken } : {}),
  };
}

export function buildRequestConfig() {
  return {
    headers: buildAuthHeaders(),
  };
}

function custompostAction(payload) {
  axios
    .post(
      getDomaine() + payload.route,
      payload.data, //convertData(payload.data),
      {
        headers: { "Content-Type": "text/plain" },
        responseType: "text",
      }
    )
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

function postAction(payload) {
  axios
    .post(
      getDomaine() + payload.route,
      payload.data, //convertData(payload.data),
      getHeader()
    )
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

function putAction(payload) {
  axios
    .put(getDomaine() + payload.route, payload.data ?? {}, getHeader())
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

function deleteAction(payload) {
  const config = {
    ...getHeader(),
    data: payload.data ?? {},
  };
  axios
    .delete(getDomaine() + payload.route, config)
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

function getAction(payload) {
  const options = getHeader();
  options.params = payload.data ?? {}; // convertData(payload.data?? {});
  axios
    .get(getDomaine() + payload.route, options)
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

function getHeader() {
  return buildRequestConfig();
}
function getDomaine(type = "api") {
  if (useCustomServer !== "") {
    return useCustomServer;
  }
  switch (type) {
    case "api":
      return config.paths.apiDomain;
    case "cloud":
      return config.paths.cloudDomain;
  }
}

function convertData(payload) {
  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    if (key === "useMethode") {
      formData.append(key, payload[key]);
    } else {
      formData.append("_flg__" + key, payload[key]);
    }
  });
  return formData;
}

export const getObjectDiff = (obj1, obj2, compareRef = false) => {
  return Object.keys(obj1).reduce((result, key) => {
    if (!obj2.hasOwnProperty(key)) {
      result.push(key);
    } else if (_.isEqual(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key);

      if (compareRef && obj1[key] !== obj2[key]) {
        result[resultKeyIndex] = `${key} (ref)`;
      } else {
        result.splice(resultKeyIndex, 1);
      }
    }
    return result;
  }, Object.keys(obj2));
};

export function loadFolderContent(payload) {
  const options = buildRequestConfig();
  axios
    .get("/api/folders/files/" + payload.folder, options)
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

export function uploadFolderContent(payload) {
  axios
    .post(getDomaine("cloud"), payload.data, buildRequestConfig())
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

export function deleteFolderContent(payload) {
  axios
    .post(payload.url, payload.data, buildRequestConfig())
    .then((response) => payload.onNext(response))
    .catch((error) => payload.onError(error))
    .finally(() => payload.onComplete());
}

export function printMe(myelement) {
  Promise.all([
    Promise.resolve('')
  ]).then((values) => {

    var cssText = `
    * {
      box-sizing: border-box;
    }
    @page {
      size: A4;
      margin: 12mm 12mm 24mm 12mm;
    }
    body {
      margin: 0;
      color: #000;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12px;
      line-height: 1.35;
      background: #fff;
    }
    #facture,
    .print-sheet {
      width: 100%;
      background: #fff;
      color: #000;
      padding: 0;
    }
    .print-document {
      width: 100%;
      min-height: auto;
      display: flex;
      flex-direction: column;
    }
    .print-main {
      width: 100%;
    }
    .row {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin: 0;
    }
    h1 {
      color: black;
      font-family: Arial, Helvetica, sans-serif;
      margin: 0 0 8px;
    }
    h3, p {
      margin: 0 0 6px;
      color: #000;
    }
    img {
      max-width: 100%;
      height: auto;
    }
    .headerP {
      width: 100%;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .logoP {
      width: 33.33%;
    }
    .steP {
      width: 41.66%;
      color: #000;
      font-size: 12px;
      text-align: right;
      background: #f2f2f2;
      padding: 10px;
      border: 1px solid #666;
      margin-bottom: 15px;
      margin-left: auto;
    }
    .emptydataCel {
      color: transparent;
      border: none;
    }
    .printBtn,
    .b-overlay,
    .spinner-border,
    .spinner-grow {
      display: none !important;
    }
    .dataCel {
      text-align: center;
      font-size: 11px;
      border: 1px solid #666;
      padding: 6px 8px;
      min-height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      overflow: hidden;
    }
    .ligne {
      width: 100%;
      page-break-inside: avoid;
    }
    .printTableRow {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .printTableRow > [class*="col-md-"] {
      box-sizing: border-box;
      padding-left: 0;
      padding-right: 0;
      min-width: 0;
    }
    .print-bottom {
      margin-top: 14px;
      padding-top: 14px;
      padding-bottom: 12mm;
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .amountSummary,
    .moreDetailBlock,
    .signatureBlock,
    .legalFooter {
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .legalFooter {
      position: fixed;
      left: 12mm;
      right: 12mm;
      bottom: 2mm;
      margin-top: 0;
      padding-top: 4mm;
      text-align: center;
      font-size: 10px !important;
      color: #555 !important;
      background: #fff;
    }
    .col-md-1 { width: 8.33%; flex: 0 0 8.33%; max-width: 8.33%; }
    .col-md-2 { width: 16.66%; flex: 0 0 16.66%; max-width: 16.66%; }
    .col-md-3 { width: 25%; flex: 0 0 25%; max-width: 25%; }
    .col-md-4 { width: 33.33%; flex: 0 0 33.33%; max-width: 33.33%; }
    .col-md-5 { width: 41.66%; flex: 0 0 41.66%; max-width: 41.66%; }
    .col-md-6 { width: 50%; flex: 0 0 50%; max-width: 50%; }
    .col-md-9 { width: 75%; flex: 0 0 75%; max-width: 75%; }
    .col-md-12 { width: 100%; flex: 0 0 100%; max-width: 100%; }
  `; 
    values.map(e => cssText+=e.data)
      const d = new Printd();
      d.print(document.getElementById(myelement), [ cssText] )
  });
}

  function numberToWords(number) {
    const units = [
      "zéro",
      "un",
      "deux",
      "trois",
      "quatre",
      "cinq",
      "six",
      "sept",
      "huit",
      "neuf",
      "dix",
      "onze",
      "douze",
      "treize",
      "quatorze",
      "quinze",
      "seize",
    ];
    const tens = [
      "",
      "dix",
      "vingt",
      "trente",
      "quarante",
      "cinquante",
      "soixante",
    ];
    const scales = [
      { value: 1000000000, singular: "milliard", plural: "milliards" },
      { value: 1000000, singular: "million", plural: "millions" },
      { value: 1000, singular: "mille", plural: "mille" },
    ];

    const integer = Number(number);
    if (!Number.isFinite(integer) || integer < 0) {
      return "";
    }
    if (integer === 0) {
      return units[0];
    }

    function joinWords(parts) {
      return parts.filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
    }

    function underHundred(value) {
      if (value < 17) {
        return units[value];
      }

      if (value < 20) {
        return `dix-${units[value - 10]}`;
      }

      if (value < 70) {
        const ten = Math.floor(value / 10);
        const unit = value % 10;
        const tenWord = tens[ten];

        if (unit === 0) return tenWord;
        if (unit === 1) return `${tenWord} et un`;
        return `${tenWord}-${units[unit]}`;
      }

      if (value < 80) {
        if (value === 71) {
          return "soixante et onze";
        }
        return `soixante-${underHundred(value - 60)}`;
      }

      if (value === 80) {
        return "quatre-vingts";
      }

      return `quatre-vingt-${underHundred(value - 80)}`;
    }

    function underThousand(value) {
      if (value < 100) {
        return underHundred(value);
      }

      const hundred = Math.floor(value / 100);
      const rest = value % 100;
      let hundredWord = hundred === 1 ? "cent" : `${units[hundred]} cent`;

      if (rest === 0 && hundred > 1) {
        hundredWord += "s";
      }

      return rest === 0 ? hundredWord : `${hundredWord} ${underHundred(rest)}`;
    }

    function convert(value) {
      if (value < 1000) {
        return underThousand(value);
      }

      for (const scale of scales) {
        if (value >= scale.value) {
          const quotient = Math.floor(value / scale.value);
          const remainder = value % scale.value;

          let prefix = "";
          if (scale.value === 1000) {
            prefix = quotient === 1 ? "mille" : `${convert(quotient)} mille`;
          } else {
            prefix =
              quotient === 1
                ? `un ${scale.singular}`
                : `${convert(quotient)} ${scale.plural}`;
          }

          return joinWords([prefix, remainder > 0 ? convert(remainder) : ""]);
        }
      }

      return "";
    }

    return convert(integer);
  }

  function capitalizeFirstLetter(value) {
    if (!value) {
      return "";
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  function shouldUseDeBeforeCurrency(value) {
    return value >= 1000000 && value % 1000000 === 0;
  }

export function amountToWords(amount) {
    const normalizedAmount = Number(amount || 0);
    if (!Number.isFinite(normalizedAmount)) {
      return "";
    }

    let dinars = Math.floor(normalizedAmount);
    let millimes = Math.round((normalizedAmount - dinars) * 1000);

    if (millimes === 1000) {
      dinars += 1;
      millimes = 0;
    }

    const dinarLabel = shouldUseDeBeforeCurrency(dinars)
      ? `de dinar${dinars !== 1 ? "s" : ""}`
      : `dinar${dinars !== 1 ? "s" : ""}`;
    let words = `${numberToWords(dinars)} ${dinarLabel}`;

    if (millimes > 0) {
      words += ` et ${numberToWords(millimes)} millime${millimes !== 1 ? "s" : ""}`;
    }

    return capitalizeFirstLetter(words);
}
